import React from 'react';
import styles from './GuildEmblem.module.css';

interface GuildEmblemProps {
  animalIcon: string;
  animalHue: number;
  animalSaturation: number;
  animalBrightness: number;
  shieldType?: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const GuildEmblem: React.FC<GuildEmblemProps> = ({
  animalIcon,
  animalHue,
  animalSaturation,
  animalBrightness,
  shieldType = 'Shield.png',
  size = 'medium',
  className = ''
}) => {
  const getAnimalColor = () => {
    // Convert hue/saturation/brightness to HSL color
    const hue = animalHue;
    const saturation = animalSaturation;
    const lightness = (animalBrightness / 100) * 50; // Map 50-150 to 25-75 lightness
    
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  };

  return (
    <div className={`${styles.emblem} ${styles[size]} ${className}`}>
      <img 
        src={`/img/guild/Shield/${shieldType}`}
        alt="Guild Shield"
        className={styles.shield}
      />
      <div 
        className={styles.animal}
        style={{
          backgroundColor: getAnimalColor(),
          WebkitMaskImage: `url(/img/guild/${animalIcon}.png)`,
          maskImage: `url(/img/guild/${animalIcon}.png)`,
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskPosition: 'center'
        }}
      />
    </div>
  );
};

export default GuildEmblem;
